import styled, { DefaultTheme } from 'styled-components';
import { Progress as AntdProgress } from 'antd';

export const Progress = styled(AntdProgress).attrs<DefaultTheme>(
  ({ theme, strokeColor }) => ({
    strokeColor: theme.darkMode ? theme.yellowDark : strokeColor
  })
)``;
